import { Setting } from '../types/constant/PagesPropsType';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import { ChangeDeliveryAddressViewType } from '../types/view/ChangeDeliveryAddressViewType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

export const useUpdateDeliveryAddress = () => {
  /**
   * お届け先設定を更新する
   *
   * @param setting
   * @param subscription
   * @param changeDeliveryAddress
   * @param success
   * @param failed
   * @param completion
   */
  const updateDeliveryAddress = (
    setting: Setting,
    subscription: SubscriptionApiType,
    changeDeliveryAddress: ChangeDeliveryAddressViewType,
    success: (deliveryData: {
      deliveryLastName: string;
      deliveryFirstName: string;
      deliveryCountryCode: string;
      deliveryZip: string;
      deliveryProvinceCode: string;
      deliveryCity: string;
      deliveryAddress1: string;
      deliveryAddress2: string;
      deliveryCompany: string;
      deliveryPhone: string;
    }) => void,
    failed: () => void,
    completion: () => void
  ) => {
    const data: {
      subscriptionId: string;
      deliveryLastName: string;
      deliveryFirstName: string;
      deliveryCountryCode: string;
      deliveryZip: string;
      deliveryProvinceCode: string;
      deliveryCity: string;
      deliveryAddress1: string;
      deliveryAddress2: string;
      deliveryCompany: string;
      deliveryPhone: string;
    } = {
      ...changeDeliveryAddress,
      subscriptionId: subscription.subscriptionContractId,
    };

    axios
      .post(
        `${CUSTOMER_API_URL}?action=updateDeliveryAddress`,
        { ...data },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success({
          ...changeDeliveryAddress,
        });
      })
      .catch((e) => {
        console.log(e);
        failed();
      })
      .finally(() => completion());
  };

  return {
    updateDeliveryAddress,
  };
};
